define('plugin/client-field/view/BuiltIn/ClientFieldBuiltInPasswordView',['require','plugin/additional-fields/view/AdditionalFieldItemView'],function (require) {

    var Parent = require('plugin/additional-fields/view/AdditionalFieldItemView');

    /**
     * Client field item view
     *
     * @class ClientFieldItemView
     */
    return Parent.extend({

        getTemplate: function () {
            return '#client_field_built_in_password';
        },
        
        setValue: function () {
            var val = this.ui.input.val();
            this.getOption('clientModel').set('password', val, {silent: true});
        },
        
        serializeData: function () {
            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                'value': this.getOption('clientModel').get('password'),
                'is_required': this.getOption('clientModel').id ? 0 : 1,
                'error': this.getOption('error')
            });
        }
        
    });

});
